export const API_BASE_URL = import.meta.env.VITE_API_URL || 'https://admin-dev.xplat360.com/api';

export const XPLAT = {
  GET_XPLAT_DATA: `${API_BASE_URL}/get-plat`,
} as const;

export const AUTH = {
	LOGIN: `${API_BASE_URL}/auth/login`,
  FORGOT_PASSWORD: `${API_BASE_URL}/auth/forgot-password`,
  VERIFY_CODE: `${API_BASE_URL}/auth/verify-code`,
  RESET_PASSWORD: `${API_BASE_URL}/auth/reset-password`,
  VALIDATE_TOKEN: `${API_BASE_URL}/auth/validate-token`
} as const;

export const INQUIRY = {
  SEND_INQUIRY: `${API_BASE_URL}/save-inquiry`,
} as const;

export const CONFIG_DATA = {
  GET_CONFIG_DATA: `${API_BASE_URL}/get-config`,
} as const;

export const URL_CONFIG = {
  FIND_REDIRECT: `${API_BASE_URL}/check-redirect`,
} as const;

export type EndpointGroup =	typeof AUTH | typeof XPLAT | typeof INQUIRY | typeof CONFIG_DATA | typeof URL_CONFIG;
